import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  BatchModelForDropdown,
  IMember,
  IMemberGridFilter,
  IMemberGridModel,
  SpecializationModelForDropdown,
} from "./types";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { memberView } from "../types/memberView";
import { ListResponse, PostModel } from "../../../common/models/baseModel";
import { AsyncOption, IDropdownModel, INameValueModel } from "common/models/IDropdownModel";

export const member = createQueryKeys("member", {
  list: (postModel: PostModel<IMemberGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<ListResponse<IMemberGridModel>>(
        endpoints.member.memberList,
        postModel
      ),
  }),
  get: (memberID: number) => ({
    queryKey: [memberID],
    queryFn: () => api.get<IMember>(`${endpoints.member.get}/${memberID}`),
  }),
  view: (memberID: number) => ({
    queryKey: [memberID],
    queryFn: () => api.get<memberView>(`${endpoints.member.view}/${memberID}`),
  }),
  pendingMembers: (postModel: PostModel<IMemberGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<ListResponse<IMemberGridModel>>(
        endpoints.member.pendingMemberList,
        postModel
      ),
  }),
  useSpecializationRoleValue: (model: SpecializationModelForDropdown) => ({
    queryKey: [model],
    queryFn: () =>
      api.post<INameValueModel[]>(
        endpoints.member.specializationRoleValue,
        model
      ),
  }),
  useBatchRoleValue: (model: BatchModelForDropdown) => ({
    queryKey: [model],
    queryFn: () =>
      api.post<INameValueModel[]>(endpoints.member.batchRoleValue, model),
  }),
  useSkillsValue: (inputValue: string, id: string) => ({
    queryKey: [inputValue, id],
    queryFn: () =>
      api.post<AsyncOption[]>(endpoints.member.useSkillsValue, {
        name: inputValue,
        id: id,
      }),
  }),
  useProgrambyCommunityValue: () => ({
    queryKey: ["getProgrambyCommunity"],
    queryFn: () =>
      api.post<IDropdownModel[]>(endpoints.member.useProgrambyCommunityValue),
  }),
});
